<!-- Optional Timer -->
<div *ngIf="workItem.status == 'In progress'" class="work-timer-wrapper">
  <app-work-list-timer [progress]="0" [itemsLength]="0"></app-work-list-timer>
</div>

<!-- Section Header -->
<div class="section-title">
  <span>{{ title }}</span>
  <span class="badge count" [ngClass]="{ picked: workItem.status === 'In progress' }">
    {{ workItem.items.length }} items
  </span>
</div>

<!-- Items -->
<div class="item-list">
  <div class="item-card" *ngFor="let item of workItem.items">
    <div class="item-left">
      <div class="name">{{ getShortProductName(item.name ?? '') }}</div>
      <div *ngIf="workItem.status !== 'In progress'" class="meta">
        SKU: {{ item.sku }} &nbsp; • Location: {{ item.location }}
      </div>
    </div>

    <div class="item-right">
      <span class="qty-label">Qty: {{ item.qty }}</span>
      <span *ngIf="item.status === 'Picked'" class="picked-badge">
        <i class="fa-solid fa-check"></i> Picked
      </span>
    </div>
  </div>
</div>
